import createFetch from "@randajan/api-kit/client";

export const apiFetch = createFetch({
    url:"/api/",
    timetrack:true
});